module.exports = __webpack_public_path__ + "static/steal-like-an-artist-2a46ce0b029c5399f027f32471802a3b.jpg";